import React from 'react';
import { connect } from 'react-redux';
import { toggleModal } from 'redux/actions/modal';
import { bindActionCreators } from 'redux';

import Info from './Info';
import Exchange from './Exchange';
import Confirm from './Confirm';
import Prize from './Prize';
import Team from './Team';
import Message from './Message';
import Login from './Login';

import 'react-responsive-modal/styles.css';
import './index.scss';

const Modal = (props) => {
	return (
		<>
			<Info {...props} />
			<Exchange {...props} />
			<Confirm {...props} />
			<Prize {...props} />
			<Team {...props} />
			<Message {...props} />
            <Login {...props} />
		</>
	);
};

function mapStateToProps(state) {
	return {
		name: state.modal.name,
		msg: state.modal.msg,
		displayClose: state.modal.close,
		isError: state.modal.error,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators({ toggleModal }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
